import store from "~/js/store/store";
import {gsap, Cubic} from "gsap";
import {handleDialogFocus, trapFocus} from "~/js/common/accessibility";

export default class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.contents = document.getElementById('cart-notification');
    this.container = this.contents.querySelector('._container');

    this.isOpen = false;

    this.close = document.querySelectorAll('.f-miniCartModalClose');
    this.btnInStock = document.querySelector('button._in_stock.on')
    this.triggeringElement = null;

    this.setup()
  }

  setup() {
    store.subscribe(((mutation, state) => {
      if (store.getters['miniCartModal']()) {
        if (!this.isOpen) {
          this.isOpen = true;
          this.triggeringElement = document.activeElement; // Store the currently focused element

          gsap.to(this.contents, {
            display: "block",
            opacity: 1,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 30
            },
            {
              marginTop: 0,
              duration: 0.6,
              ease: Cubic.easeOut
            }
          );

          setTimeout(function () {
            this.contents.focus();
            handleDialogFocus(this.contents);
          }.bind(this), 500);
        }
      } else {
        if (this.isOpen) {
          this.isOpen = false;

          gsap.to(this.contents, {
            display: "none",
            opacity: 0,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 0
            },
            {
              marginTop: 30,
              duration: 0.3,
              ease: Cubic.easeIn
            }
          );

          // Return focus to the triggering element or fallback
          this.returnFocus();
        }
      }
    }));

    this.close.forEach((elm, index) => {
      elm.addEventListener('click', (event) => {
        store.dispatch('setMiniCartModal', {
          sta: false
        });

        if (this.btnInStock && document.body.contains(this.btnInStock)) {
          trapFocus(this.btnInStock)
        } else {
          // Fallback to body if triggering element is not available
          document.body.focus();
        }
      });
    });

    this.handleTriggerFocus()
  }

  handleTriggerFocus() {
    const btnInStock = document.querySelector('button._in_stock.on')
    document.addEventListener('keydown', function (event) {
      if (['ESCAPE'].includes(event?.code?.toUpperCase())) {
        store.dispatch('setMiniCartModal', {
          sta: false
        });

        if (btnInStock && document.body.contains(btnInStock)) {
          trapFocus(btnInStock)
        } else {
          // Fallback to body if triggering element is not available
          document.body.focus();
        }
      }
    })
  }

  returnFocus() {
    if (this.triggeringElement && document.body.contains(this.triggeringElement)) {
      this.triggeringElement.focus();
    } else {
      // Fallback to body if triggering element is not available
      document.body.focus();
    }
  }

  open() {
    store.dispatch('setMiniCartModal', {
      sta: true
    });
  }

  close() {
    store.dispatch('setMiniCartModal', {
      sta: false
    });
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      },
      {
        id: 'cart-notification-button',
        section: 'cart-notification-button'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
